// Fuel Vietnamese translations
export const fuelVi = {
  'add.fuel.receipt': 'Thêm Hoá Đơn Xăng Dầu',
  'all.vehicles.fuel.efficiency': 'Hiệu Suất Nhiên Liệu - Tất Cả Phương Tiện',
  'recalculate.last.30.days': 'Tính Lại 30 Ngày Gần Nhất',
  'create.fuel.receipt': 'Tạo hóa đơn xăng dầu',
  'continue.anyway': 'Bạn có muốn tiếp tục không?',
  'duplicate.receipt.warning': 'Số Hóa Đơn Trùng Lặp',
  'edit.fuel.receipt': 'Chỉnh Sửa Hoá Đơn Xăng Dầu',
  'efficiency.liters.per.100km': 'Lít/100km',
  'error.saving.fuel.receipt': 'Lỗi khi lưu hóa đơn xăng dầu',
  'existing.record': 'Bản ghi đã tồn tại',
  'fuel.cost': 'Chi Phí Xăng Dầu',
  'fuel.efficiency': 'Hiệu Suất Nhiên Liệu',
  'fuel.efficiency.calculator': 'Máy Tính Hiệu Suất Nhiên Liệu',
  'fuel.efficiency.chart': 'Biểu Đồ Hiệu Suất Nhiên Liệu',
  'fuel.efficiency.history': 'Lịch Sử Hiệu Suất Nhiên Liệu',
  'fuel.efficiency.summary': 'Tóm Tắt Hiệu Suất Nhiên Liệu',
  'fuel.receipt.created': 'Tạo hóa đơn xăng dầu thành công',
  'fuel.receipt.management': 'Quản Lý Hoá Đơn Xăng Dầu',
  'fuel.receipt.saved.as.draft': 'Đã lưu hóa đơn xăng dầu ở trạng thái nháp',
  'fuel.receipt.updated': 'Cập nhật hóa đơn xăng dầu thành công',
  'fuel.tank.capacity': 'Dung Tích Bình Xăng (L)',
  'gas.station': 'Trạm Xăng',
  'link.fuel.receipt': 'Liên Kết Hoá Đơn Xăng Dầu',
  'linked.fuel.receipts': 'Hoá Đơn Xăng Dầu Đã Liên Kết',
  'liters': 'Lít',
  'no.fuel.receipts.linked': 'Không có hoá đơn xăng dầu nào được liên kết',
  'no.unlinked.fuel.receipts': 'Không có hoá đơn xăng dầu chưa liên kết',
  'odometer': 'Số Km',
  'odometer.reading': 'Odometer Reading',
  'please.enter.valid.liters': 'Vui lòng nhập số lít hợp lệ',
  'receipt.number': 'Số Hóa Đơn',
  'receipt.number.already.exists': 'Số hóa đơn',
  'already.exists.in.database': 'đã tồn tại trong cơ sở dữ liệu',
  'refuel.date': 'Refuel Date',
  'requires.odometer.readings': 'Yêu cầu ít nhất 2 hóa đơn có số km đồng hồ',
  'select.fuel.receipt.to.link': 'Chọn hoá đơn xăng dầu để liên kết',
  'total.fuel': 'Tổng Nhiên Liệu',
  'total.fuel.cost': 'Tổng Chi Phí Xăng Dầu',
  'upload.fuel.receipt.image': 'Upload Fuel Receipt Image',
  'view.fuel.efficiency': 'Xem Hiệu Suất Nhiên Liệu',
  'view.fuel.receipts': 'Xem Hóa Đơn Xăng Dầu',
};
